import './lib/AnimationEasing';

import './component/Analytics';
import './component/hubspotForm';

// NOTE: Colorbox must see jQuery on the window in order to work properly
import * as $ from 'jquery';
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;

/* This carousel has been modified to primarily work on locationTour */
import Carousel from './component/Carousel';
const carouselElem = document.querySelector('body.__locationTour .carousel');
if (carouselElem) {
	new Carousel({
		analyticsCategory: 'Carousel',
		carouselEl: carouselElem as HTMLElement,
		duration: 7500,
		allowIndicatorClick: true,
		allowLooping: false,
		autoHeight: true,
		startingIndex: -1,
		progressEl: carouselElem as HTMLElement
	});
}

import locationTour from './component/locationTour';
locationTour();